import {Inject, Injectable, Renderer2, RendererFactory2} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {LocalStoreService} from '@commonShared/services/local-storage.service';
import {BrandName} from '@commonShared/models';

@Injectable({
  providedIn: 'root'
})
export class AccessibilityService {
  private readonly _hiContrastStyle = `hi-contrast`;
  private readonly _highContrastMode = 'HighContrastMode';
  private renderer: Renderer2;

  constructor(private localStoreService: LocalStoreService,
              private rendererFactory: RendererFactory2,
              @Inject(DOCUMENT) private document: Document) {
    this.renderer = rendererFactory.createRenderer(null, null);
    this.changeContrast(this.isHighContrast());
  }

  toggleContrast(): void {
    const currentMode = this.isHighContrast();
    this.changeContrast(!currentMode);
    this.saveState(!currentMode);
  }

  setContrast(val: boolean): void {
    this.saveState(val);
    this.changeContrast(val);
  }

  private changeContrast(isHighContrast: boolean): void {
    const body: any = this.document.body;

    if (!isHighContrast) {
      this.renderer.removeClass(body, this._hiContrastStyle);
    } else {
      this.renderer.addClass(body, this._hiContrastStyle);
    }
  }

  private saveState(isHighContrast: boolean): void {
    this.localStoreService.saveData(this._highContrastMode, isHighContrast.toString());
  }

  private isHighContrast(): boolean {
    return this.localStoreService.getData(this._highContrastMode) === 'true';
  }

  getBarrierFreeInfoPath(brand: string): string | null {
    switch (brand) {
      case BrandName.PROAMA.toLowerCase(): {
        return 'https://www.proama.pl/obsluga-bez-barier';
      }
      case BrandName.GENERALI.toLowerCase(): {
        return 'https://www.generali.pl/obsluga-bez-barier';
      }
      default: {
        return null;
      }
    }
  }
}
